// extracted by mini-css-extract-plugin
var _1 = "metaboliteprofile_buttonWrapper";
var _2 = "metaboliteprofile_copy";
var _3 = "metaboliteprofile_infoGroup";
var _4 = "metaboliteprofile_infoWrapper";
var _5 = "metaboliteprofile_metaboliteProfile";
var _6 = "metaboliteprofile_top";
export { _1 as "buttonWrapper", _2 as "copy", _3 as "infoGroup", _4 as "infoWrapper", _5 as "metaboliteProfile", _6 as "top" }
